import { TimeUnitEnum } from '@/constants/enum';
import { ITimeUnit } from '@/types';
import BoldSmallText from '../BoldSmallText';
import RegularText from '../RegularText';
import { differenceInCalendarDays } from 'date-fns';

export const HelpTextTime = ({ time, lowercase = false, addTime }: { time: ITimeUnit; lowercase?: boolean; addTime?: ITimeUnit }) => {
  const getText = (text: string) => (lowercase ? text.toLowerCase() : text);

  const now = new Date();
  const target = new Date(now);

  const getTotalMinutes = (unit: TimeUnitEnum, value: number): number => {
    switch (unit) {
      case TimeUnitEnum.DAY:
        return value * 1440;
      case TimeUnitEnum.HOUR:
        return value * 60;
      case TimeUnitEnum.MINUTE:
        return value;
      default:
        return 0;
    }
  };

  let totalMinutes = getTotalMinutes(time.unit as TimeUnitEnum, Number(time.value));

  if (addTime) {
    totalMinutes += getTotalMinutes(addTime.unit as TimeUnitEnum, Number(addTime.value));
  }

  target.setMinutes(target.getMinutes() + totalMinutes);

  const diffDays = differenceInCalendarDays(target, now);

  if (diffDays <= 0) {
    return (
      <RegularText>
        {getText('The first available date buyer can see is')}{' '}
        <BoldSmallText as="span">today</BoldSmallText>
      </RegularText>
    );
  } else if (diffDays === 1) {
    return (
      <RegularText>
        {getText('The first available date buyer can see is')}{' '}
        <BoldSmallText as="span">tomorrow</BoldSmallText> (today counts as day 1).
      </RegularText>
    );
  } else {
    return (
      <RegularText>
        {getText('The first available date buyer can see is')}{' '}
        <BoldSmallText as="span">{diffDays} days from today</BoldSmallText> (today counts as day 1).
      </RegularText>
    );
  }
};